import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";

const faqs = [
  { 
    question: "Is FLEXX Academy a trading platform?", 
    answer: "No. FLEXX Academy provides only educational and collaborative content — not a trading or execution platform. We do not execute trades, manage accounts, or provide brokerage services." 
  },
  { 
    question: "Do you provide trading signals or strategies?", 
    answer: "No. We do not send any trading signals, market calls, or strategy recommendations. Our focus is on education, helping you develop the knowledge and frameworks to make your own informed decisions." 
  },
  { 
    question: "Is this financial advice?", 
    answer: "No. All content is educational and general in nature. It does not constitute financial advice or guidance. We strongly recommend consulting with qualified financial advisors before making any investment decisions." 
  },
  { 
    question: "Do you promote specific tools or platforms?", 
    answer: "No. FLEXX Academy maintains platform-agnostic and neutral positioning for all educational purposes. We do not promote or endorse specific trading platforms, tools, or services." 
  }
];

const FAQItem = ({ question, answer, isOpen, onClick, testId }) => {
  return (
    <div className="faq-item" data-testid={testId}>
      <button className={`faq-trigger ${isOpen ? 'open' : ''}`} onClick={onClick}>
        <span className="faq-question">{question}</span>
        <ChevronDown className={`faq-chevron ${isOpen ? 'rotated' : ''}`} />
      </button>
      {isOpen && (
        <div className="faq-content">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="section-primary">
      <div className="section-pattern"></div>
      
      <div className="container">
        <div className="section-header">
          <div className="section-icon">
            <HelpCircle />
          </div>
          <h2 className="section-title">FAQ</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openFAQ === index}
              onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
              testId={`faq-item-${index}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
